import {DebugLogButton} from '@github-ui/copilot-shared-ui/components/DebugLogButton'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'

import {isAhpDebugLogEnabled} from '../../ahp/ahp-debug-log'
import {useActivationTraceUrl} from '../../hooks/use-activation-trace-url'
import {useAhpDebugEvents} from '../../hooks/use-ahp-debug-events'
import {useConnectionTraceUrl} from '../../hooks/use-connection-trace-url'

/**
 * Staff-only viewer for the AHP relay transport log recorded for this task,
 * matching the debug log button Quick Chat renders in its conversation header.
 */
export function TaskDebugLogButton({
  taskId,
  sessionId,
  size = 'medium',
}: {
  taskId: string | undefined
  sessionId?: string
  size?: 'small' | 'medium'
}) {
  // The staff check reads a browser-only meta tag that is absent during SSR, so
  // `isBrowser` keeps the server and first hydration renders identical.
  const {isBrowser} = useRuntimeEnvironment()
  const taskDebugEvents = useAhpDebugEvents(taskId)
  const sessionDebugEvents = useAhpDebugEvents(sessionId)
  const debugEvents = taskDebugEvents.length > 0 ? taskDebugEvents : sessionDebugEvents
  const activationTraceUrl = useActivationTraceUrl(taskId, sessionId)
  const connectionTraceUrl = useConnectionTraceUrl(taskId, sessionId)

  if (!isBrowser || !isAhpDebugLogEnabled()) return null

  return (
    <DebugLogButton
      debugEvents={debugEvents}
      activationTraceUrl={activationTraceUrl}
      connectionTraceUrl={connectionTraceUrl}
      size={size}
      testId="debug-log-button"
    />
  )
}
